import * as t from "io-ts";

interface AesCipherKeyBrand {
  readonly AesCipherKey: unique symbol;
}
export const AesCipherKey = t.brand(t.string,
  (n): n is t.Branded<string, AesCipherKeyBrand> => true,
  "AesCipherKey");
export type AesCipherKey = t.TypeOf<typeof AesCipherKey>;

interface AesIvBrand {
  readonly AesIv: unique symbol;
}
export const AesIv = t.brand(t.string,
  (n): n is t.Branded<string, AesIvBrand> => true,
  "AesIv");
export type AesIv = t.TypeOf<typeof AesIv>;

export const AesKeyWithIvData = t.type({
  key: AesCipherKey,
  iv: AesIv,
});
export type AesKeyWithIvData = t.TypeOf<typeof AesKeyWithIvData>;
